module.exports = __webpack_public_path__ + "static/media/logo.31b2e9de.png";